import React from 'react';
import { connect } from 'react-redux';

import makeStyles from '@mui/styles/makeStyles';

import LoadingIndicator from '@apps/shared/src/components/LoadingIndicator';
import { colors } from '@apps/shared/src/style/colors';
import { Provider } from '@apps/shared/src/providerSearchAdmin/types/providerSearch';

import AppLayout from '../shared/AppLayout';
import PageSpecificHeader from '../shared/PageSpecificHeader';
import ProviderSearchUpdatePane from './ProviderSearchUpdatePane';
import VirtualizedProviderList from './VirtualizedProviderList';
import { RootState } from '../store';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    height: 'calc(100vh - 6vh - 0.5rem)',
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    height: '93vh',
    overflowY: 'hidden',
  },
}));

type StateProps = {
  providerList: Provider[];
  isLoadingProviderList: boolean;
};

const ProviderSearchUpdate: React.FC<StateProps> = ({
  providerList,
  isLoadingProviderList,
}: StateProps): JSX.Element => {
  const classes = useStyles();

  return (
    <AppLayout>
      <PageSpecificHeader title="Provider Search" description="" />
      <div className={classes.container}>
        <ProviderSearchUpdatePane />
        {isLoadingProviderList && (!providerList || providerList.length < 1) ? (
          <LoadingIndicator isLoading={isLoadingProviderList} size={75} color={colors.orange} />
        ) : (
          <section className={classes.content}>
            <VirtualizedProviderList providerList={providerList} />
          </section>
        )}
      </div>
    </AppLayout>
  );
};

const mapStateToProps = ({ providerSearchAdmin }: RootState): StateProps => ({
  providerList: providerSearchAdmin.providers,
  isLoadingProviderList: providerSearchAdmin.isLoadingProviderList,
});

export default connect(mapStateToProps, null)(ProviderSearchUpdate);
